module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/entriesIn.js
// module id = 204
// module chunks = 0